import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { WidgetProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    label: {
      marginTop: theme.spacing(2),
    },
  });

interface ConsentWidgetProps extends WidgetProps<boolean>, WithStyles<typeof styles> {}

export const ConsentWidgetComponent = (props: ConsentWidgetProps) => {
  const { id, value, label, required, disabled, classes, onChange, onBlur, onFocus } = props;

  // If Consent is required, then trigger a validation error if the value is !== true, by passing up null (i.e. will
  // generate a type error that we can interpret as 'Field is required' in transformErrors), otherwise, simply pass
  // up false if Consent is optional
  const uncheckedValue = required ? null : false;

  const handleChange = (event: any) => {
    onChange(event.target.checked || uncheckedValue);
  };

  const handleBlur =
    onBlur &&
    ((event: any) => {
      onBlur(id, event.target.checked || uncheckedValue);
    });

  const handleFocus =
    onFocus &&
    ((event: any) => {
      onFocus(id, event.target.checked || uncheckedValue);
    });

  return (
    <FormControlLabel
      control={
        <Checkbox
          id={id}
          checked={value || false}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
      }
      label={label}
      classes={{ root: classes.label }}
    />
  );
};

export const ConsentWidget = withStyles(styles)(ConsentWidgetComponent);
